export default class ScriptsBasic {
  constructor(options = {}) {
    this.options = options
    this.schemaQuestions = options.schemaQuestions || {}
    this.completeQuestions = options.completeQuestions || {}
    this.surveySchema = this.options.getSurveySchema()
    this._initScriptsBasic()
  }

  _initScriptsBasic() {
    this._complete = this.completeQuestions.reduce((acc, cur) => {
      const type = cur.variant || cur.type

      if (!['rb', 'cb', 'mx'].includes(type)) return acc

      const id = (cur.position && this._getQuestionId(cur.position)) || cur.id

      if (['rb', 'cb'].includes(type)) {
        acc[type] = acc[type] || {}
        acc[type][id.toUpperCase()] = cur.answerVariants.map(v => v.text)
      }
      if (['mx'].includes(type)) {
        acc['rb'] = acc['rb'] || {}
        acc['rb'][1 < cur.batches.length ? `${id.toUpperCase()}SQ1-${cur.batches.length}` : `${id.toUpperCase()}SQ1`] =
          (cur.batches[0].answerVariants || cur.answerVariants).map(v => v.text)
      }

      return acc
    }, {})
  }

  _getQuestionId(position) {
    const question = this.surveySchema.questions.find(q => q.position == position)
    if (!question) return null
    const type = question.pre_type != undefined ? 'PQ' : 'Q'
    return `${type}${question.visual_position}`
  }

  _getMXBasicData() {
    const _keys = Object.keys(this._complete.rb || {})
    const _passed = []

    const _data = _keys
      .reduce((acc, cur) => {
        if (_passed.includes(cur)) return acc

        const _values = []

        _passed.push(cur)
        _values.push(cur)

        _keys.forEach(k => {
          if (_passed.includes(k)) return

          if (this._complete.rb[cur].every((v, i) => v == this._complete.rb[k][i])) {
            _passed.push(k)
            _values.push(k)
          }
        })

        acc.push(_values)

        return acc
      }, [])
      .filter(v => 1 < v.length)
      .map(v => v.join(','))

    return {
      data: _data.map(v => {
        return { text: v, value: v }
      })
    }
  }

  generateBasicData(script) {
    if ('mx' == script) {
      return this._getMXBasicData()
    }

    return {}
  }
}
